module.exports = __webpack_public_path__ + "img/icon-total-cost.5ef06206.svg";